

define(['angular', 'squid/index', './directive'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('xo-fullpage-onetouch-upsell.route', ['squid', 'xo-fullpage-onetouch-upsell.directive']).factory('$FullpageOnetouchUpsellRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('FullpageOnetouchUpsellRoute', {

            name: 'FullpageOnetouchUpsell',
            directive: 'xo-fullpage-onetouch-upsell',
            trackingData: {},
            children: []
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-login-components/src/fullpage-onetouch-upsell/route.js
// module id = ./components/xo-login-components/src/fullpage-onetouch-upsell/route.js
// module chunks = 1